import React from 'react';
import { Container } from 'react-bootstrap';
import './Terms.css';

const Terms = () => {
  return (
    <Container className="home-page-wrapper">
      <h6>TERMS OF SERVICE</h6>
      <p>Effective Date: Nov 23, 2024</p>

      <p>
        Welcome to Sunthar's hub! By accessing or using our platform at Sunthar.com, you agree to be bound by the following
        terms of service (“Terms”). If you do not agree, you may not access or use the platform.
      </p>

      <p>
        Users of the site are responsible for their own actions. Some tutorials and modifications may involve handling higher voltage
        electricity or other potentially dangerous activities. It is the user's responsibility to perform due diligence before attempting
        any modifications. Sunthar assumes no responsibility for any injuries, damages, or other consequences arising from the use of the platform.
      </p>

      <ol className="terms-list">
        <li>
          <strong>About Sunthar</strong>
          <p>
            Sunthar offers support services and allows select users to sell modification kits. The platform does not operate as a general
            marketplace but provides guidance and tools for modifications.
          </p>
        </li>

        <li>
          <strong>Eligibility</strong>
          <ul>
            <li>Must be at least 18 years old or have legal capacity in your jurisdiction.</li>
            <li>Agree to comply with these Terms and all applicable laws.</li>
          </ul>
        </li>

        <li>
          <strong>User Responsibilities</strong>
          <p>
            Users must ensure they fully understand the risks involved in any modifications or tutorials before proceeding. Any modifications,
            particularly those involving electrical components, should be performed with caution and at the user's own risk.
          </p>
        </li>

        <li>
          <strong>Prohibited Activities</strong>
          <ul>
            <li>Posting or selling adult content, pornography, or explicit material.</li>
            <li>Listing or promoting illegal, stolen, or hazardous items.</li>
            <li>Engaging in fraud, misrepresentation, or abusive behavior.</li>
            <li>Violating intellectual property rights or posting copyrighted content without authorization.</li>
            <li>Selling products that infringe on copyrights (e.g., mod chips, injectors, dumpers).</li>
            <li>Sharing instructions for modding or jailbreaking game consoles.</li>
          </ul>
          <p>Sunthar reserves the right to remove any content or listing violating these Terms.</p>
        </li>

        <li>
          <strong>Content Ownership</strong>
          <ul>
            <li>
              <strong>User-Generated Content:</strong> By posting content, you grant Sunthar a non-exclusive, royalty-free,
              worldwide license to use, display, and distribute your content.
            </li>
            <li>
              <strong>Content credits:</strong> Your content will be credited to you with the name you choose to publish it under. You will be able to edit your content at any time. Published content requires admin approval to be removed.
            </li>
            <li>
              <strong>Platform branding:</strong> Platform content can be referenced for non-commercial purposes, as long as a link to the original content and author information is included.
            </li>
          </ul>
        </li>

        <li>
          <strong>Liability Disclaimer</strong>
          <ul>
            <li>Sunthar is not responsible for the accuracy or legality of user-generated content.</li>
            <li>Users assume all risks associated with following tutorials, performing modifications, or using any products available through the platform.</li>
            <li>Sunthar does not guarantee the quality or authenticity of any third-party modification kits.</li>
          </ul>
        </li>

        <li>
          <strong>Dispute Resolution</strong>
          <p>
            All disputes related to modifications or support services should be resolved between the involved parties. Sunthar does not mediate disputes but
            reserves the right to suspend or terminate accounts involved in fraudulent activities.
          </p>
        </li>

        <li>
          <strong>Termination</strong>
          <p>Sunthar reserves the right to suspend or terminate accounts for:</p>
          <ul>
            <li>Violating these Terms or applicable laws.</li>
            <li>Posting prohibited or inappropriate content.</li>
            <li>Engaging in fraud or abusive behavior.</li>
          </ul>
        </li>

        <li>
          <strong>Modification of Terms</strong>
          <p>
            Sunthar may update these Terms periodically. Changes take effect upon posting, and continued use of the platform
            constitutes acceptance of the updates.
          </p>
        </li>

        <li>
          <strong>Contact Information</strong>
          <p>
            For inquiries regarding these Terms, contact us at
            <a href="mailto:support@sunthar.com"> support@sunthar.com</a>.
          </p>
          <p>By using this site, you acknowledge that you have read, understood, and agree to these Terms.</p>
        </li>
      </ol>
    </Container>
  );
};

export default Terms;
